var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonDrop',{ref:"drop",attrs:{"label-name":"accountName","url":"/settings/account/list","autoDefault":false,"size":"mini"},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }